const validate = (name, value, formData) => {

    let error = { status: false, message: '' }
    let isField = schema[name];
  

    const fieldNames = {
        JobMasterID: 'Job Title',
        Interviewee:'Interviewee',
        InterviewerID:'Primary Interviewer',
        SecondaryInterviewerIDs:'Secondary Interviewer',
        InterviewDate:'Interview Date',
        // InterviewTime: ['select'],
        Round: 'Round',
        FeedbackCategory:'Feedback Template',
        InterviewMode:'Interview Mode'
    };
    if (isField) {
        let validation = isField;
        for (let i = 0; i < validation.length; i++) {
            switch (validation[i]) {
                case 'required':
                    if (formData[name] == ''|| typeof formData[name]==undefined) {
                        error = { status: true, message: `${fieldNames[name]} is required` };
                        return error;
                    }
                break;
                case 'select':
                    if (!formData[name]?.value || formData[name]?.value === "") {
                        error = { status: true, message: `${fieldNames[name]} is required` };
                        return error;
                    }
                break;      
            }
        }
    }
    return error;
}
const schema = {
    JobMasterID: ['select'],
    Interviewee: ['required'],
    InterviewerID: ['select'],
    SecondaryInterviewerIDs: ['select'],
    InterviewDate: ['required'],
    // InterviewTime: ['select'],
    Round: ['select'],
    FeedbackCategory:['select'],
    InterviewMode:['select']
}
export default validate;
